import React, { useEffect, useState } from "react";
import Contenedor from "../../Utils/Visuales/Contenedor";
import { Grid } from "@material-ui/core";
import { getRequest, postRequest } from "../../Utils/Funciones/requester";
import { useSnackbar } from "notistack";
import Select from "react-select";
import styles from "./styles.module.css";
import { useSelector } from "react-redux";
import { CustomSpinner } from "../../Utils/Loader";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import NewButton from "../../Utils/Botones/NewButton";
import NewModal from "../../Utils/Visuales/NewModal";
import CreateInternalParametersModal from "../../Utils/CreateInternalParametersModal";
import { validateInternalParameters } from "../../Utils/Funciones/validateInternalParameters";
import { getDataParameters } from "../../Utils/Funciones/getDataParameters";
import CustomTable from "../../Utils/CustomTable";
import { teachingAssignmentMaximumTeachingLoadHeader } from "../../Utils/data/teachingAssignmentMaximumTeachingLoadHeader";
import { specialClassesTotalHoursHeader } from "../../Utils/data/specialClassesTotalHoursHeader";
import moment from "moment";
import EditButton from "../../Utils/Botones/EditButton";
import { getCampusCatalog } from "../../Utils/Funciones/getCampusCatalog";
import { getSchools, getSchoolsClave } from "../../Utils/Funciones/getSchools";
import { formatString } from "../../Utils/Funciones/removeCharacterFromString";
import { getGroupType } from "../../Utils/Funciones/getGroupType";
import { getTabulators } from "../../Utils/Funciones/getTabulators";
import { SelectTipoClaseParametro64 } from "../../Utils/data/SelectTipoClaseParametro64";
import { convertDateForParameters } from "../../Utils/Funciones/convertDateForParameters";
import { getDefaultHeadersForParameters } from "../../Utils/Funciones/getDefaultHeadersForParameters";
import { getPersonCatalog } from "../../Utils/Funciones/getPersonCatalog";
import NewTraduccionInterfaceNominaAgrupadorHorasOnlineModal from "../Modals/NewTraduccionInterfaceNominaAgrupadorHorasOnlineModal";
import EditTraduccionInterfaceNominaAgrupadorHorasOnlineModal from "../Modals/EditTraduccionInterfaceNominaAgrupadorHorasOnlineModal";
import EditConfiguracionMostrarTiposDeGruposOnline from "../Modals/EditConfiguracionMostrarTiposDeGruposOnline";
import EditAsignacionDocenteAlumnosInscritos from "../Modals/EditAsignacionDocenteAlumnosInscritos";
import AsignacionDocenteOnlineOnlineAlumnosInscritos from "../Modals/AsignacionDocenteOnlineOnlineAlumnosInscritos";
import { orderParametosInternos } from "../../Utils/Funciones/orderParametosInternos";
import EditarConceptosDePagoParaGruposCerrados from "../Modals/EditarConceptosDePagoParaGruposCerrados";
import CreateConceptosDePagoParaGruposCerrados from "../Modals/CreateConceptosDePagoParaGruposCerrados";
import { ConceptosDePagoParaGruposCerradosHeader } from "../../Utils/data/ConceptosDePagoParaGruposCerradosHeader";
import DynamicSelectTable from "../../components/DynamicSelectTable";
import TrashIcon from "../../components/TrashIcon";
import EditConfiguracionAsignacionDocenteEscuelasProfesor from "../Modals/EditConfiguracionAsignacionDocenteEscuelasProfesor";

const consultarConcepto = async (id, enqueueSnackbar) => {
  try {
    const consulta = `/catalogo?id=${id}`;
    const response = await getRequest(consulta);
    let data = [];
    if (response.s === "OK") {
      let id = response.d.elementos[0].id;
      let clave = response.d.elementos[1].clave;
      let nombre = response.d.elementos[2].descripcion;
      id.forEach((item, i) => {
        data.push({
          value: id[i],
          label: `${clave[i]} - ${nombre[i]}`,
          clave: clave[i],
          nombre: nombre[i],
        });
      });
      return data;
    } else {
      enqueueSnackbar(response.m, {
        variant: "error",
        autoHideDuration: null,
      });
    }
  } catch (error) {
    console.error(error);
    enqueueSnackbar(error, {
      variant: "error",
      autoHideDuration: null,
    });
  }
};

const ParametrosInternos = () => {
  const [loading, setLoading] = useState(false);
  const [loadingMDis, setLoadingMDis] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const { permisos, userName, campusId, campusUser2 } = useSelector(
    (state) => state
  );
  const [valueProceso, setValueProceso] = useState("");
  const [optionsProceso, setOptionsProceso] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [dataFinal, setDataFinal] = useState([]);
  const [dataOriginal, setDataOriginal] = useState([]);
  const [dataTypeOf, setDataTypeOf] = useState("");
  const [tableEdit, setTableEdit] = useState(false);
  const [creadoYModificado, setCreadoYModificado] = useState({});
  const [createName, setCreateName] = useState("");
  const [createDay, setCreateDay] = useState("");
  const [createMonth, setCreateMonth] = useState("");
  const [createPayble, setCreatePayble] = useState("");
  const [createAssistanceType, setCreateAssistanceType] = useState("");
  const [createCurrent, setCreateCurrent] = useState("S");
  const [createClaveEscuela52, setCreateClaveEscuela52] = useState("");
  const [createSemanas52, setCreateSemanas52] = useState("");
  const [createCarrera52, setCreateCarrera52] = useState("");
  const [createDays63, setCreateDays63] = useState("");
  const [createSchool63, setCreateSchool63] = useState("");
  const [createModulo52, setCreateModulo52] = useState("");
  const [columns, setColumns] = useState([
    {
      accessorKey: "nombre",
      header: "Nombre",
      enableEditing: false,
    },
    {
      accessorKey: "valor",
      header: "Valor",
    },
  ]);
  const [openModalSelectTable, setOpenModalSelectTable] = useState(false);
  const procesoMap = {
    10: {
      row: "excepcion_total_horas_por_escuela",
      title: "Configurar Escuelas a Excluir",
    },
    32: {
      row: "escuelas",
      title: "Configuración Escuelas para Validar Profesión Profesor",
      maxWidth: 900,
    },
    71: {
      row: "escuelas",
      title: "Configuración Escuelas para Validar Profesión Profesor",
      maxWidth: 900,
    },
  };
  const [filaEditar, setFilaEditar] = useState(null);
  const [valoresTipoClase, setValoresTipoClase] = useState([]);
  const [valoresPorcentaje, setValoresPorcentaje] = useState([]);
  const [valoresSelectTable, setValoresSelectTable] = useState([]);
  const [sumaTotalPorcentaje, setsumaTotalPorcentaje] = useState(null);
  const [valoresModalDis, setValoresModalDis] = useState("");
  const [estatus, setEstatus] = useState("");
  const estatusOptions = [
    { label: "Vigente", value: "vigente" },
    { label: "No Vigente", value: "no vigente" },
  ];
  const [nroFilas, setNroFilas] = useState([]);
  const [formDataParam50, setFormDataParam50] = useState({
    clve_camp_fnza: "",
    clve_crra: "",
    porcentaje: "",
  });
  const [dataModalParam60, setDataModalParam60] = useState([]);
  const tipoClaseCatalogo = SelectTipoClaseParametro64;
  const [campusCatalogo, setCampusCatalogo] = useState([]);
  const [escuelasCatalogo, setEscuelasCatalogo] = useState([]);
  const [tipoGrupoCatalogo, setTipoGrupoCatalogo] = useState([]);
  const [tabuladoresCatalogo, setTabuladoresCatalogo] = useState([]);
  const [campusSelectedOptions, setCampusSelectedOptions] = useState("");
  const [escuelasSelectedOptions, setEscuelasSelectedOptions] = useState("");
  const [tipoGrupoSelectedOptions, setTipoGrupoSelectedOptions] = useState("");
  const [options, setOptions] = useState({
    escuelas: [],
    campus: [],
  });

  const [title, setTitle] = useState({
    nombre: "",
    original: "",
  });
  const [groupTypeList, setGroupTypeList] = useState([]);
  const [personList, setPersonList] = useState([]);
  const [tabuladoresSelectedOptions, setTabuladoresSelectedOptions] =
    useState("");
  const [estatusSelectedOptions, setEstatusSelectedOptions] = useState("");
  const [modalOptions, setModalOptions] = useState([]);
  const [editeParamModals, setEditeParamModals] = useState({
    param04: false,
    param10: false,
    param32: false,
    param35: false,
    param50: false,
    param58: false,
    param62: false,
    param64: false,
    param66: false,
    param67: false,
    param68: false,
    param69: false,
    param70: false,
  });
  const [createParamModals, setCreateParamModals] = useState({
    param16: false,
    param50: false,
    param52: false,
    param58: false,
    param60: false,
    param62: false,
    param63: false,
    param68: false,
    param70: false,
  });

  useEffect(() => {
    getCampusCatalog().then((campus) => {
      const activeCampus = campus
        .filter((item) => item.active === "1")
        .map((item) => ({
          ...item,
        }));
      setOptions((prev) => ({ ...prev, campus: activeCampus }));
    });
    getSchoolsClave().then((school) => {
      const activeSchool = school.map((item) => ({
        ...item,
      }));
      setOptions((prev) => ({ ...prev, escuelas: activeSchool }));
    });
    consultarConcepto(6, enqueueSnackbar).then((conceptos) => {
      setOptions((prev) => ({ ...prev, conceptos }));
    });
  }, [enqueueSnackbar]);

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    const newData = getDataParameters(
      dataTypeOf,
      dataOriginal,
      row,
      values,
      valueProceso,
      userName
    );
    if (newData !== false) {
      try {
        const payload = { id: valueProceso, data: newData };
        switch (valueProceso) {
          case 65:
            const str = values.valor_dias;
            const isOnlyNumbers = (str) => /^\d+$/.test(str);
            const num = parseInt(str);
            if (num < 0 || isNaN(num) || !isOnlyNumbers(str)) {
              return enqueueSnackbar("Valor dia debe de ser numerico", {
                variant: "error",
                autoHideDuration: null,
              });
            }
            break;
          default:
            break;
        }

        const response = await postRequest(`/parametro_reglas`, payload);

        if (response.s === "OK") {
          enqueueSnackbar(response.m, { variant: "success" });
          setShowTable(false);
          setTableEdit(false);
          getDataTable(valueProceso);
        } else {
          enqueueSnackbar(response.m, {
            variant: "error",
            autoHideDuration: null,
          });
        }
      } catch (error) {}
      exitEditingMode(); //required to exit editing mode
    }
  };

  const GetListParametro = async () => {
    try {
      setLoading(true);
      const consulta = `/parametro_reglas`;
      const response = await getRequest(consulta);
      if (response.s === "OK") {
        let arrayResponse = response.d.map((e) => {
          const data2 = {
            label: `${e.id} - ${formatString(e.nombre)}`,
            value: e.id,
          };
          return data2;
        });
        setOptionsProceso(arrayResponse);
      }
      setShowTable(false);
      setLoading(false);
    } catch (error) {}
  };

  useEffect(() => {
    const suma = valoresPorcentaje?.reduce((total, subarreglo) => {
      return (
        total + (isNaN(parseInt(subarreglo[0])) ? 0 : parseInt(subarreglo[0]))
      );
    }, 0);
    setsumaTotalPorcentaje(suma);
  }, [valoresPorcentaje]);

  const getDataTable = async (value) => {
    setShowTable(false);
    setColumns([]);
    try {
      setValueProceso(value);
      setLoading(true);
      setCreadoYModificado({});
      const request = `/parametro_reglas?id=${value}`;
      const response = await getRequest(request);
      if (response.s === "OK") {
        if (value === 58) {
          setValoresModalDis(response.d.data);
        }

        setShowTable(true);
        enqueueSnackbar(response.m, { variant: "success" });
        setCreadoYModificado(response.d);
        if (Array.isArray(response?.d?.data)) {
          setDataTypeOf("array");
          setDataOriginal(response?.d?.data);
          switch (value) {
            case 7:
            case 17:
              setColumns(teachingAssignmentMaximumTeachingLoadHeader);
              break;
            case 21:
            case 22:
            case 23:
              setColumns(specialClassesTotalHoursHeader);
              break;
            case 70:
              setColumns(ConceptosDePagoParaGruposCerradosHeader);
              break;
            default:
              const elementos_map = Object.keys(
                response.d?.data?.[0] === undefined ? {} : response.d?.data?.[0]
              );
              const headers = elementos_map.map((element) => {
                if (element === "active" || element === "id") {
                  return null;
                }
                return getDefaultHeadersForParameters(element, valueProceso);
              });
              setColumns(headers.filter((element) => element !== null));
              break;
          }
          // set date for table
          const dataTable = response.d.data.map((element, index) => {
            const keys = Object.keys(element);
            const rowData = {};
            keys.forEach((key) => {
              if (Array.isArray(element[key])) {
                rowData[key] = element[key].join(",");
              } else {
                rowData[key] = element[key];
              }
            });
            return { ...rowData, id: index };
          });
          setDataOriginal(
            response.d.data.map((element, index) => {
              return { ...element, id: index };
            })
          );
          dataTable.sort((a, b) =>
            a?.clave_escuela > b?.clave_escuela
              ? 1
              : b?.clave_escuela > a?.clave_escuela
              ? -1
              : 0
          );
          setDataFinal(dataTable);
          setLoading(false);
        } else if (
          typeof response.d?.data === "object" &&
          !Array.isArray(response.d?.data) &&
          response.d?.data !== null
        ) {
          setDataTypeOf("json");
          setColumns([
            { accessorKey: "nombre", header: "Nombre", enableEditing: false },
            { accessorKey: "valor", header: "Valor" },
          ]);
          // set date for table
          const dataTable = Object.keys(response.d?.data).map((key) => {
            return {
              nombre: key,
              valor: Array.isArray(response.d?.data[key])
                ? response.d?.data[key].join(",")
                : response.d?.data[key],
            };
          });
          setDataOriginal(response.d.data);
          setDataFinal(orderParametosInternos(value, dataTable));
          setLoading(false);
        }
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
        setShowTable(false);
        setLoading(false);
      }
    } catch (error) {}
  };

  const handleClickEditTable = (event) => {
    setShowTable(false);
    setCreadoYModificado(null);
    setTableEdit(event.target.checked);
    getDataTable(valueProceso, event.target.checked);
  };

  const handleCloseCreateModal = () => {
    setCreateParamModals((prev) => ({ ...prev, param16: false }));
  };

  const handleSubmitCreateModal = async () => {
    const check = validateInternalParameters(
      createName,
      createDay,
      createMonth,
      createPayble,
      createAssistanceType,
      createCurrent
    );
    if (check === true) {
      const newData = dataOriginal;
      newData.push({
        id: newData.length,
        nombre: createName,
        dia: parseInt(createDay),
        mes: parseInt(createMonth),
        pagable: createPayble,
        tipo_asistencia: [createAssistanceType],
        Vigente: createCurrent,
      });
      try {
        const payload = { id: valueProceso, data: newData };
        const response = await postRequest(`/parametro_reglas`, payload);

        if (response.s === "OK") {
          enqueueSnackbar(response.m, {
            variant: "success",
          });
          setCreateParamModals((prev) => ({ ...prev, param16: false }));
          setShowTable(false);
          setTableEdit(false);
          getDataTable(valueProceso);
        } else {
          enqueueSnackbar(response.m, {
            variant: "error",
            autoHideDuration: null,
          });
        }
      } catch (error) {}
    }
  };

  const agregarNuevaFila = (nroFilas) => {
    if (nroFilas.length === 0) setValoresTipoClase([]);

    let filas = [...nroFilas];
    filas.push([0, 0]);

    if ([10, 32, 71].includes(valueProceso)) {
      valoresSelectTable.push(null);
    } else if (valueProceso === 64) {
      valoresTipoClase.push(null);
    } else {
      valoresPorcentaje.push([0, 0]);
    }

    setNroFilas(filas);
  };

  const deleteRow = (idx) => {
    let state, setState;

    if ([10, 32, 71].includes(valueProceso)) {
      [state, setState] = [valoresSelectTable, setValoresSelectTable];
    } else if ([64, 66, 67, 69].includes(valueProceso)) {
      [state, setState] = [valoresTipoClase, setValoresTipoClase];
    } else {
      [state, setState] = [valoresPorcentaje, setValoresPorcentaje];
    }
    const newValues = [...state];
    newValues.splice(idx, 1);
    // actualizar estados
    setState(newValues);
    setNroFilas(newValues);
  };

  const handleSubmitDis = async () => {
    if (sumaTotalPorcentaje > 100) {
      enqueueSnackbar("El porcentaje total no puede ser mayor a 100", {
        variant: "error",
        autoHideDuration: null,
      });
      return;
    } else if (nroFilas.length === 0) {
      enqueueSnackbar("Se debe de agregar al menos un Porcentaje", {
        variant: "error",
      });
      setLoadingMDis(false);
    }

    setLoadingMDis(true);
    if (sumaTotalPorcentaje !== null) {
      dataFinal[filaEditar].Porcentaje = sumaTotalPorcentaje;
    }
    if (estatus.label !== undefined) {
      dataFinal[filaEditar].Estatus = estatus.label;
    }
    const convertedData = valoresPorcentaje.map(
      (pair) => `${pair[0]}% => ${pair[1]}`
    );
    const result = convertedData.join(", ");
    dataFinal[filaEditar].Distribucion = result;

    try {
      const payload = { id: valueProceso, data: dataFinal };
      const response = await postRequest(`/parametro_reglas`, payload);

      if (response.s === "OK") {
        enqueueSnackbar(response.m, { variant: "success" });
        setShowTable(false);
        getDataTable(valueProceso);
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setEditeParamModals((prev) => ({ ...prev, param58: false }));
      setLoadingMDis(false);
    }
  };

  const handleInputChange = (index, e) => {
    const newData = [...dataModalParam60];
    newData[index] = e.target.value;
    setDataModalParam60(newData);
  };

  const handleSubmitParam60Nuevo = async () => {
    const filtrados = dataModalParam60.filter((elemento) => {
      return elemento !== "" && elemento !== null && elemento !== undefined;
    });

    if (filtrados.length < 3) {
      enqueueSnackbar("Todos los campos son obligatorios", {
        variant: "error",
        autoHideDuration: null,
      });
      return;
    }
    setLoadingMDis(true);
    const nuevoRegistro = {
      clave_escuela: dataModalParam60[0],
      clave_grupo: dataModalParam60[1],
      dias: dataModalParam60[2],
    };

    dataFinal.push(nuevoRegistro);

    try {
      const payload = { id: valueProceso, data: dataFinal };
      const response = await postRequest(`/parametro_reglas`, payload);

      if (response.s === "OK") {
        enqueueSnackbar(response.m, { variant: "success" });
        setShowTable(false);
        getDataTable(valueProceso);
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setCreateParamModals((prev) => ({ ...prev, param60: false }));
      setLoadingMDis(false);
      setDataModalParam60([]);
    }
  };

  const handleSubmit52Nuevo = async () => {
    let valid = true;
    if (createClaveEscuela52 === "") {
      valid = false;
      enqueueSnackbar("Se debe de agregar una Clave Escuela", {
        variant: "error",
        autoHideDuration: null,
      });
      return;
    } else if (createSemanas52 === "") {
      valid = false;
      enqueueSnackbar("Se debe de agregar un Numero de Semana", {
        variant: "error",
        autoHideDuration: null,
      });
      return;
    } else if (createCarrera52 === "") {
      valid = false;
      enqueueSnackbar("Se debe de agregar una Clave Carrera", {
        variant: "error",
        autoHideDuration: null,
      });
      return;
    } else if (createModulo52 === "") {
      valid = false;
      enqueueSnackbar("Se debe de agregar una Modulo", {
        variant: "error",
        autoHideDuration: null,
      });
      return;
    }
    valid = !dataFinal.some(
      (item) =>
        createClaveEscuela52 === item.clave_esc &&
        createSemanas52 === item.num_semanas
    );

    if (!valid) {
      enqueueSnackbar(
        "Ya existe un registro para esa Clave Escuela y Numero de Semana",
        { variant: "error", autoHideDuration: null }
      );
      return;
    }
    if (valid) {
      try {
        setLoadingMDis(true);
        const newData = [...dataFinal];
        newData.push({
          clave_esc: createClaveEscuela52,
          num_semanas: createSemanas52,
          clave_crra: createCarrera52,
          horas_modulo: createModulo52,
          id: dataFinal.length,
        });
        const payload = { id: valueProceso, data: newData };
        const response = await postRequest(`/parametro_reglas`, payload);
        if (response.s === "OK") {
          enqueueSnackbar(response.m, { variant: "success" });
          getDataTable(valueProceso);
          setCreateClaveEscuela52("");
          setCreateSemanas52("");
          setCreateCarrera52("");
          setCreateModulo52("");
          setLoadingMDis(false);
          setCreateParamModals((prev) => ({ ...prev, param52: false }));
        } else {
          setLoadingMDis(false);
          enqueueSnackbar(response.m, {
            variant: "error",
            autoHideDuration: null,
          });
        }
      } catch (error) {}
    }
  };
  const handleSubmitDisNuevo = async () => {
    if (sumaTotalPorcentaje > 100) {
      enqueueSnackbar("El porcentaje total no puede ser mayor a 100", {
        variant: "error",
        autoHideDuration: null,
      });
      return;
    }
    try {
      setLoadingMDis(true);
      let valid = !valoresModalDis.some(
        (item) =>
          campusSelectedOptions?.value === item.id_campus &&
          escuelasSelectedOptions?.value === item.id_escuela
      );
      const newData = [...valoresModalDis];
      newData.push({
        Campus: campusSelectedOptions?.label,
        Escuela: escuelasSelectedOptions?.label,
        Porcentaje: sumaTotalPorcentaje,
        Distribucion: valoresPorcentaje
          .map((item) => {
            return `${item[0]}% => ${item[1]}`;
          })
          .join(", "),
        Estatus: "Vigente",
        Creado: moment().format("YYYY-MM-DD HH:mm"),
        Creado_por: userName,
        Modificado: "",
        Modificado_por: "",
        id: valoresModalDis.length,
        id_campus: campusSelectedOptions?.value,
        id_escuela: escuelasSelectedOptions?.value,
      });
      const payload = { id: valueProceso, data: newData };
      if (nroFilas.length === 0) {
        enqueueSnackbar("Se debe de agregar al menos un Porcentaje", {
          variant: "error",
        });
      } else if (
        campusSelectedOptions?.value === undefined ||
        escuelasSelectedOptions?.value === undefined
      ) {
        enqueueSnackbar("Se debe de agregar una escuela y un campus", {
          variant: "error",
        });
      } else if (valid) {
        const response = await postRequest(`/parametro_reglas`, payload);
        if (response.s === "OK") {
          enqueueSnackbar(response.m, { variant: "success" });
          getDataTable(valueProceso);
          setCreateParamModals((prev) => ({ ...prev, param58: false }));
          setLoadingMDis(false);
          setNroFilas([]);
          setValoresPorcentaje([]);
          setsumaTotalPorcentaje(null);
          setCampusSelectedOptions("");
          setEscuelasSelectedOptions("");
        } else {
          enqueueSnackbar(response.m, {
            variant: "error",
            autoHideDuration: null,
          });
        }
      } else {
        enqueueSnackbar(
          "Ya existe un registro para el campus y escuela insertados",
          { variant: "error", autoHideDuration: null }
        );
      }
    } finally {
      setLoadingMDis(false);
    }
  };
  const handleSubmitParametro62 = async () => {
    if (
      escuelasSelectedOptions?.value === undefined ||
      tipoGrupoSelectedOptions?.value === undefined ||
      tabuladoresSelectedOptions?.value === undefined
    ) {
      return enqueueSnackbar(
        "Se debe de agregar una escuela, un tipo de grupo y un tabulador",
        { variant: "error" }
      );
    }

    try {
      const newData = [];
      if (createParamModals?.param62) {
        const valid = !dataFinal.some(
          (item) =>
            escuelasSelectedOptions.value === item.clave_escuela &&
            tipoGrupoSelectedOptions.value === item.tipo_grupo
        );
        if (!valid) {
          return enqueueSnackbar(
            "Ya existe un registro para la Escuela y Tipo de Grupo seleccionado",
            { variant: "error", autoHideDuration: null }
          );
        }

        newData.push({
          clave_escuela: escuelasSelectedOptions?.value,
          tipo_grupo: tipoGrupoSelectedOptions?.value,
          tabulador: tabuladoresSelectedOptions?.label,
          estatus: "Activo",
          creado: moment().format("YYYY-MM-DD HH:mm"),
          creado_por: userName,
          modificado: "",
          modificado_por: "",
        });
      } else {
        newData.push({
          clave_escuela: escuelasSelectedOptions?.value,
          tipo_grupo: tipoGrupoSelectedOptions?.value,
          tabulador: tabuladoresSelectedOptions?.label,
          estatus: estatusSelectedOptions?.value,
          modificado: `${moment().format("YYYY-MM-DD HH:mm:ss")}`,
          modificado_por: `${userName}`,
        });
      }
      setLoadingMDis(true);

      const payload = { id: valueProceso, data: newData };
      const response = await postRequest(`/parametro_reglas`, payload);
      if (response.s === "OK") {
        enqueueSnackbar(response.m, { variant: "success" });
        getDataTable(valueProceso);
        setCreateParamModals((prev) => ({ ...prev, param62: false }));
        setEditeParamModals((prev) => ({ ...prev, param62: false }));
        setEscuelasSelectedOptions("");
        setTabuladoresSelectedOptions("");
        setTipoGrupoSelectedOptions("");
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setLoadingMDis(false);
    }
  };

  const handleSubmitParametro64 = async () => {
    const values = valoresTipoClase.map((item) => item?.value);
    const duplicados = new Set(values).size !== values.length;
    if (valoresTipoClase.length === 0) {
      return enqueueSnackbar("Se debe ingresar al menos una clase especial", {
        variant: "error",
      });
    }

    if (duplicados) {
      return enqueueSnackbar("No se permiten registros duplicados", {
        variant: "error",
      });
    }
    const labelValues = valoresTipoClase
      .map((item) => item?.label)
      .filter((label) => label !== undefined);
    const labelString = labelValues.join(", ");
    dataFinal[0].valor = labelString;
    const json = Object.fromEntries(
      dataFinal.map((item) => [item.nombre, item.valor])
    );

    try {
      setLoadingMDis(true);
      const payload = { id: valueProceso, data: json };
      const response = await postRequest("/parametro_reglas", payload);

      if (response.s === "OK") {
        enqueueSnackbar(response.m, { variant: "success" });
        setTableEdit(false);
        getDataTable(valueProceso);
        setEditeParamModals((prev) => ({ ...prev, param64: false }));
        setNroFilas([]);
        setValoresTipoClase([]);
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setLoadingMDis(false);
    }
  };

  const handleSubmitParametro66 = async () => {
    const stringValor = valoresTipoClase.map((valor) => valor.label);
    const json = dataFinal.map((item) => {
      if (item.nombre === title.original) {
        return { ...item, valor: stringValor.join(", ") };
      }
      return { ...item };
    });
    try {
      setLoadingMDis(true);
      const payload = {
        id: valueProceso,
        data: { tipo_grupo: json[0].valor, tipo_persona: json[1].valor },
      };

      const response = await postRequest("/parametro_reglas", payload);

      if (response.s === "OK") {
        enqueueSnackbar(response.m, { variant: "success" });
        setTableEdit(false);
        getDataTable(valueProceso);
        setEditeParamModals((prev) => ({ ...prev, param66: false }));
        setNroFilas([]);
        setValoresTipoClase([]);
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setLoadingMDis(false);
    }
  };

  const handleSubmitParametro50 = async () => {
    let nuevoRegistro = {};

    for (let clave in formDataParam50) {
      if (formDataParam50.hasOwnProperty(clave)) {
        if (formDataParam50[clave] === "") {
          return enqueueSnackbar(
            "Se debe de agregar un campo clave finanza, una carrera y un porcentaje",
            { variant: "error" }
          );
        }
      }
    }

    if (createParamModals?.param50) {
      const valid = !dataFinal.some(
        (item) =>
          formDataParam50.clve_camp_fnza === item.clve_camp_fnza &&
          formDataParam50.clve_crra === item.clve_crra
      );
      if (!valid) {
        return enqueueSnackbar(
          "Ya existe un registro para el Campo Clave Finanza y la Carrera seleccionada",
          { variant: "error", autoHideDuration: null }
        );
      }

      nuevoRegistro = {
        ...formDataParam50,
        estatus: createParamModals?.param50 ? "Activo" : estatusSelectedOptions,
        creado: moment().format("YYYY-MM-DD HH:mm"),
        creado_por: userName,
        modificado: "",
        modificado_por: "",
      };
      dataFinal.push(nuevoRegistro);
    } else {
      const nuevoRegistro = {
        ...dataFinal[filaEditar],
        ...formDataParam50,
        estatus: estatusSelectedOptions.value,
        modificado: moment().format("YYYY-MM-DD HH:mm:ss"),
        modificado_por: userName,
      };
      dataFinal[filaEditar] = nuevoRegistro;
    }
    try {
      setLoadingMDis(true);
      const payload = { id: valueProceso, data: dataFinal };
      const response = await postRequest(`/parametro_reglas`, payload);
      if (response.s === "OK") {
        enqueueSnackbar(response.m, { variant: "success" });
        getDataTable(valueProceso);
        setCreateParamModals((prev) => ({ ...prev, param50: false }));
        setEditeParamModals((prev) => ({ ...prev, param50: false }));
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setLoadingMDis(false);
      setFormDataParam50({
        clve_camp_fnza: "",
        clve_crra: "",
        porcentaje: "",
        estatus: "Activo",
      });
    }
  };

  const handleSubmitParamSelectTable = async () => {
    try {
      setLoadingMDis(true);

      if (valueProceso === 10 && valoresSelectTable.length === 0)
        return enqueueSnackbar("Se debe ingresar al menos una escuela", {
          variant: "error",
        });

      const hasEmptyElements = valoresSelectTable.some(
        (elm) => elm === "" || elm === null
      );

      if (valueProceso === 10 && hasEmptyElements)
        return enqueueSnackbar("Debe ingresar escuela", { variant: "error" });

      const arregloValores = valoresSelectTable
        .map((elemento) => {
          const match = elemento?.label?.match(/\d+/); // Encuentra números en la cadena
          return match ? match[0] : null; // Devuelve el número encontrado o null
        })
        .filter((valor) => valor !== null);

      dataFinal[0].valor = dataFinal[0]?.valor?.split(",");
      dataFinal[2].valor = arregloValores;

      const json = Object.fromEntries(
        dataFinal.map((item) => [item.nombre, item.valor])
      );

      const payload = { id: valueProceso, data: json };
      const response = await postRequest("/parametro_reglas", payload);

      if (response.s === "OK") {
        enqueueSnackbar(response.m, { variant: "success" });
        setTableEdit(false);
        getDataTable(valueProceso);
        setOpenModalSelectTable(false);
        setNroFilas([]);
        setValoresSelectTable([]);
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setLoadingMDis(false);
    }
  };

  useEffect(() => {
    GetListParametro();
    getSchools().then((schools) => {
      setEscuelasCatalogo(schools);
    });
    getGroupType().then((group) => {
      setGroupTypeList(group);
    });
    getPersonCatalog().then((people) => {
      setPersonList(
        people.map((person) => {
          return {
            label: person.label,
            value: person.clave,
          };
        })
      );
    });
  }, []);

  const handleChangeEscuela52 = (e) => {
    setCreateClaveEscuela52(e.target.value);
  };

  const handleChangeSemanas52 = (e) => {
    const inputValue = e.target.value;
    if (/^\d+$/.test(inputValue)) {
      setCreateSemanas52(inputValue);
    }
  };

  const handleChangeDays63 = (e) => {
    const inputValue = e.target.value;
    if (/^\d+$/.test(inputValue)) {
      setCreateDays63(inputValue);
    } else if (e === "") {
      setCreateDays63("");
    }
  };

  const handleChangeCarrera52 = (e) => {
    setCreateCarrera52(e.target.value);
  };

  const handleChangeModulo52 = (e) => {
    const inputValue = e.target.value;
    if (/^\d+$/.test(inputValue)) {
      setCreateModulo52(inputValue);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataParam50((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleOpenModalCreate = (id) => {
    setCreateParamModals((prev) => ({ ...prev, [`param${id}`]: true }));
  };

  const handleSubmit63Nuevo = async () => {
    const sameSchool = dataFinal.some(
      (school) =>
        parseInt(school.clave_escuela) === parseInt(createSchool63?.clave)
    );
    if (createSchool63?.value === "" || createSchool63 === "") {
      enqueueSnackbar("Se debe seleccionar una escuela", {
        variant: "error",
        autoHideDuration: null,
      });
    } else if (createDays63 === "") {
      enqueueSnackbar("Se debe insertar los dias", {
        variant: "error",
        autoHideDuration: null,
      });
    } else if (sameSchool) {
      enqueueSnackbar("Ya existe un registro con la escuela selecionada", {
        variant: "error",
        autoHideDuration: null,
      });
    } else {
      const body = [
        ...dataFinal,
        {
          clave_escuela: `${createSchool63?.clave}`,
          dias_previos: parseFloat(createDays63),
          creado: moment().format("YYYY-MM-DD HH:mm"),
          creado_por: `${userName} ${moment().format("YYYY-MM-DD HH:mm:ss")}`,
          modificado_por: `${userName}`,
          modificado: moment().format("YYYY-MM-DD HH:mm"),
          id: dataFinal[dataFinal.length - 1]?.id + 1,
        },
      ];
      const payload = { id: valueProceso, data: body };
      try {
        setLoadingMDis(true);
        const response = await postRequest("/parametro_reglas", payload);
        if (response.s === "OK") {
          enqueueSnackbar(response.m, { variant: "success" });
          setCreateSchool63("");
          setCreateDays63("");
          setCreateParamModals((prev) => ({ ...prev, param63: false }));
          getDataTable(valueProceso);
        } else {
          enqueueSnackbar(response.m, {
            variant: "error",
            autoHideDuration: null,
          });
        }
      } finally {
        setLoadingMDis(false);
      }
    }
  };

  const handleNroFilas = (valor) => {
    const newValor = valor.filter((element) => element?.value !== "");
    setNroFilas(newValor.length ? newValor : [0]);
    setTitle({
      nombre: valor[0].nombre,
      original: valor[0].original,
    });
  };

  const handleValorTipoClase = (valor) => {
    switch (valueProceso) {
      case 4:
      case 35:
        if (valor[0]?.nombre === "escuelas") {
          const valorArry = escuelasCatalogo
            ?.filter((school) =>
              valor.find((item) => item.value === school.clave)
            )
            .map((item) => ({ ...item, nombre: valor[0].nombre }));
          setModalOptions(escuelasCatalogo);
          setNroFilas(valorArry);
          setValoresTipoClase(valorArry);
        } else {
          const valorArry = valor.map((item) => ({
            label: item.value,
            value: item.value,
            clave: item.value,
            nombre: item.nombre,
          }));
          setValoresTipoClase(valorArry);
          setModalOptions([
            { label: "periodo", value: "periodo", clave: "periodo" },
            { label: "fecha", value: "fecha", clave: "fecha" },
          ]);
        }
        break;
      case 32:
        {
          const valorArry = valor.map((item) => item.value);
          setValoresTipoClase(
            valorArry.length
              ? groupTypeList.filter((grupo) => valorArry.includes(grupo.value))
              : []
          );
        }
        break;
      case 66:
        {
          const valorArry = valor.filter((item) => item.value !== "");
          setValoresTipoClase(valorArry.length ? valor : []);
        }
        break;
      case 67:
      case 69:
        {
          const valorArry = valor.map((item) => item.value);
          setValoresTipoClase(
            valorArry.length
              ? escuelasCatalogo
                  .filter((school) => valorArry.includes(school.clave))
                  .map((school) => ({
                    ...school,
                  }))
              : []
          );
        }
        break;
      default:
        setValoresTipoClase(valor);
        break;
    }
  };

  const handleSubmitParametro67 = async () => {
    const stringValor = valoresTipoClase.map((valor) => valor.value);
    const json = dataFinal.map((item) => {
      if (item.modalidad === title.original) {
        return {
          modalidad: item.modalidad,
          tipos_grupos: stringValor.join(","),
        };
      }
      return { modalidad: item.modalidad, tipos_grupos: item.tipos_grupos };
    });
    try {
      setLoadingMDis(true);
      const payload = { id: valueProceso, data: json };
      const response = await postRequest("/parametro_reglas", payload);

      if (response.s === "OK") {
        enqueueSnackbar(response.m, { variant: "success" });
        setTableEdit(false);
        getDataTable(valueProceso);
        setEditeParamModals((prev) => ({ ...prev, param67: false }));
        setNroFilas([]);
        setValoresTipoClase([]);
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setLoadingMDis(false);
    }
  };

  const checkCreateButton = (proceso) => {
    switch (proceso) {
      case 16:
      case 52:
      case 63:
      case 68:
        return true;
      case 70:
        return true;
      default:
        return false;
    }
  };

  return (
    <Contenedor title="Configuración / Parámetros Internos del Sistema">
      <CustomSpinner visible={loading} />
      <Grid container style={{ marginBottom: 20, marginTop: 10 }}>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          style={{ justifyContent: "space-around" }}
        >
          <Grid
            container
            spacing={2}
            style={{ width: "100%", display: "flex", alignItems: "center" }}
          >
            <Grid xs={6} sm={1} item>
              <label>Proceso(*):</label>
            </Grid>
            <Grid xs={6} sm={5} item style={{ padding: 2, zIndex: 99 }}>
              <Select
                className="select-modal-container input-campus"
                classNamePrefix="select-modal"
                value={valueProceso.value}
                defaultValue=""
                options={optionsProceso}
                onChange={(e) => {
                  setTableEdit(false);
                  getDataTable(e.value);
                }}
                isDisabled={loading}
              />
            </Grid>
            {showTable && (
              <>
                <Grid item xs={12} sm={4} style={{ paddingLeft: "24px" }}>
                  <FormGroup>
                    <FormControlLabel
                      style={{
                        width: 80,
                        display:
                          permisos["Configuración->Parámetros Internos"]
                            .modificar === "1"
                            ? "block"
                            : "none",
                      }}
                      control={
                        <Switch
                          checked={tableEdit}
                          onChange={handleClickEditTable}
                        />
                      }
                      label="Editar"
                    />
                  </FormGroup>
                </Grid>
                {valueProceso === 58 && (
                  <Grid item xs={12} sm={2} style={{ textAlign: "end" }}>
                    <NewButton
                      customText="Crear"
                      noIcon
                      style={{ padding: "5px 15px" }}
                      onClick={() => {
                        setLoadingMDis(true);
                        setCreateParamModals((prev) => ({
                          ...prev,
                          param58: true,
                        }));
                        Promise.all([getCampusCatalog(), getSchools()])
                          .then(([campusData, schoolsData]) => {
                            setCampusCatalogo(campusData);
                            setEscuelasCatalogo(schoolsData);
                          })
                          .catch((error) => {
                            setCreateParamModals((prev) => ({
                              ...prev,
                              param58: false,
                            }));
                          })
                          .finally(() => {
                            setLoadingMDis(false);
                          });
                      }}
                    />
                  </Grid>
                )}
                {valueProceso === 50 && (
                  <Grid item xs={12} sm={2} style={{ textAlign: "end" }}>
                    <NewButton
                      customText="Crear"
                      noIcon
                      style={{ padding: "5px 15px" }}
                      onClick={() => {
                        setCreateParamModals((prev) => ({
                          ...prev,
                          param50: true,
                        }));
                      }}
                    />
                  </Grid>
                )}
                {valueProceso === 62 && (
                  <Grid item xs={12} sm={2} style={{ textAlign: "end" }}>
                    <NewButton
                      customText="Crear"
                      noIcon
                      style={{ padding: "5px 15px" }}
                      onClick={() => {
                        setLoadingMDis(true);
                        setCreateParamModals((prev) => ({
                          ...prev,
                          param62: true,
                        }));

                        Promise.all([
                          getSchoolsClave(),
                          getGroupType(),
                          getTabulators(),
                        ])
                          .then(
                            ([schoolsData, groupTypeData, tabulatorsData]) => {
                              setEscuelasCatalogo(schoolsData);
                              setTipoGrupoCatalogo(groupTypeData);
                              setTabuladoresCatalogo(tabulatorsData);
                            }
                          )
                          .catch((error) => {
                            setCreateParamModals((prev) => ({
                              ...prev,
                              param62: false,
                            }));
                          })
                          .finally(() => {
                            setLoadingMDis(false);
                          });
                      }}
                    />
                  </Grid>
                )}
                {valueProceso === 60 && (
                  <Grid item xs={12} sm={2} style={{ textAlign: "end" }}>
                    <NewButton
                      customText="Crear"
                      noIcon
                      style={{ padding: "5px 15px" }}
                      onClick={() => {
                        setLoadingMDis(true);
                        setCreateParamModals((prev) => ({
                          ...prev,
                          param60: true,
                        }));
                        setLoadingMDis(false);
                      }}
                    />
                  </Grid>
                )}
              </>
            )}
            {showTable && checkCreateButton(valueProceso) && (
              <Grid item xs={12} sm={2} style={{ textAlign: "-webkit-right" }}>
                <NewButton
                  customText="Crear"
                  noIcon
                  style={{
                    padding: "5px 15px",
                    display:
                      permisos["Configuración->Divisionales"].escribir === "1"
                        ? "block"
                        : "none",
                  }}
                  disabled={false}
                  onClick={() => handleOpenModalCreate(valueProceso)}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>

      {showTable && (
        <Grid>
          <CustomTable
            data={loading ? [] : convertDateForParameters(dataFinal)}
            headers={columns}
            loading={loading}
            isEditarDisabled={tableEdit}
            onEditingRowSave={handleSaveRow}
            isDeleteButton={false}
            setFormDataParam50={setFormDataParam50}
            setValoresTipoClase={handleValorTipoClase}
            setLoadingMDis={setLoadingMDis}
            setEscuelasSelectedOptions={setEscuelasSelectedOptions}
            setTipoGrupoSelectedOptions={setTipoGrupoSelectedOptions}
            setTabuladoresSelectedOptions={setTabuladoresSelectedOptions}
            setEstatusSelectedOptions={setEstatusSelectedOptions}
            setEscuelasCatalogo={setEscuelasCatalogo}
            setTipoGrupoCatalogo={setTipoGrupoCatalogo}
            setTabuladoresCatalogo={setTabuladoresCatalogo}
            setFilaEditar={setFilaEditar}
            setValoresPorcentaje={setValoresPorcentaje}
            valoresModalDis={valoresModalDis}
            setNroFilas={handleNroFilas}
            valueProceso={valueProceso}
            setEditeParamModals={setEditeParamModals}
          />
          {[10, 32, 71].includes(valueProceso) && tableEdit && (
            <NewButton
              customText="Editar"
              noIcon
              style={{
                padding: "5px 15px",
                position: "absolute",
                marginTop: "-138px",
                left: "45px",
              }}
              onClick={async () => {
                setOpenModalSelectTable(true);
                setLoadingMDis(true);
                const data = await getSchools();
                setEscuelasCatalogo(data);
                const nombre = procesoMap[valueProceso].row || null;
                const filaEditar = dataFinal.find((ob) => ob.nombre === nombre);
                const arreglo = filaEditar.valor
                  .split(",")
                  .map((label) => label.trim())
                  .filter((label) => label !== "");

                setNroFilas(arreglo);

                let valoresFiltrados = data.reduce((result, elemento) => {
                  if (arreglo.some((label) => elemento.label.includes(label)))
                    result.push(elemento);
                  return result;
                }, []);

                if (valoresFiltrados.length === 0) agregarNuevaFila(nroFilas);

                setValoresSelectTable(valoresFiltrados);
                setLoadingMDis(false);
              }}
            />
          )}
          <Grid
            container
            style={{
              marginBottom: 40,
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <Grid item>Creado:</Grid>
            <Grid item xs={3}>
              <input
                className="filter-input"
                value={creadoYModificado.creado_por}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <input
                className="filter-input"
                value={moment(creadoYModificado.creado).format(
                  "YYYY-MM-DD HH:mm:ss"
                )}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item> Modificado:</Grid>
            <Grid item xs={3}>
              <input
                className="filter-input"
                value={creadoYModificado.modificado_por}
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <input
                className="filter-input"
                value={
                  creadoYModificado.modificado !== null
                    ? moment(creadoYModificado.modificado).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )
                    : ""
                }
                disabled
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
      {createParamModals?.param16 && (
        <NewModal
          title={`Crear Día Festivo`}
          open={createParamModals?.param16}
          handleClose={handleCloseCreateModal}
          handleSubmit={handleSubmitCreateModal}
        >
          <CreateInternalParametersModal
            setName={setCreateName}
            setDay={setCreateDay}
            setMonth={setCreateMonth}
            setPayble={setCreatePayble}
            setAssistanceType={setCreateAssistanceType}
            setCurrent={setCreateCurrent}
          />
        </NewModal>
      )}
      <NewModal
        title="Configurar Distribución"
        open={createParamModals?.param58}
        handleClose={() => {
          setCreateParamModals((prev) => ({ ...prev, param58: false }));
          setEstatus("");
          setLoadingMDis(false);
          setNroFilas([]);
          setValoresPorcentaje([]);
          setCampusSelectedOptions("");
          setEscuelasSelectedOptions("");
        }}
        height={600}
        maxWidth={700}
        loading={loadingMDis}
        overflowY={"auto"}
        handleSubmit={handleSubmitDisNuevo}
      >
        <div style={{ padding: "25px" }}>
          <Grid
            container
            spacing={1}
            style={{
              marginBottom: "30px",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Grid item xs={3}>
              <label className={styles.inputLabel}>Campus:</label>
            </Grid>
            <Grid item xs={8}>
              <Select
                id="campus"
                className="select-modal-container"
                classNamePrefix="select-modal"
                style={{ width: "200px" }}
                options={[...campusCatalogo]}
                value={campusSelectedOptions}
                onChange={setCampusSelectedOptions}
                isClearable={true}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Escuela:</label>
            </Grid>
            <Grid item xs={8}>
              <Select
                id="campus"
                className="select-modal-container"
                classNamePrefix="select-modal"
                style={{ width: "200px" }}
                options={[...escuelasCatalogo]}
                value={escuelasSelectedOptions}
                onChange={setEscuelasSelectedOptions}
                isClearable={true}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Porcentaje:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                value={
                  sumaTotalPorcentaje || valoresModalDis[filaEditar]?.Porcentaje
                }
                disabled
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Estatus:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                value={"Vigente"}
                disabled
              />
            </Grid>
          </Grid>
        </div>
        <Grid
          item
          xs={12}
          className="consult-tab-option_center"
          style={{ marginTop: "-4%" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "2%",
              marginRight: "5%",
              height: "30px",
            }}
          >
            <EditButton onClick={() => agregarNuevaFila(nroFilas)}>
              Agregar
            </EditButton>
          </div>
          <div>
            <table
              className="input-table"
              style={{ width: "78%", marginTop: "1%" }}
            >
              <tr>
                <th>Porcentaje Parcial</th>
                <th>Porcentaje a Otorgar</th>
              </tr>
              {nroFilas.map((_, i) => (
                <tr key={i}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <input
                        className="filter-input"
                        style={{ width: "35%" }}
                        type="number"
                        min={0}
                        max={100}
                        value={valoresPorcentaje?.[i]?.[0]}
                        onChange={(e) => {
                          const nuevosValores = [...valoresPorcentaje];
                          nuevosValores[i][0] = e.target.value;
                          setValoresPorcentaje(nuevosValores);
                        }}
                      />
                      <span>%</span>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <input
                        className="filter-input"
                        type="number"
                        style={{ width: "35%" }}
                        min={0}
                        max={100}
                        value={valoresPorcentaje?.[i]?.[1]}
                        onChange={(e) => {
                          const nuevosValores = [...valoresPorcentaje];
                          nuevosValores[i][1] = e.target.value;
                          setValoresPorcentaje(nuevosValores);
                        }}
                      />
                      <span>%</span>
                    </div>
                  </td>
                  <td>
                    <div
                      className="table-delete"
                      style={{ marginLeft: "38.5%", zIndex: 99 }}
                      onClick={() => deleteRow(i)}
                    >
                      <TrashIcon />
                    </div>
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </Grid>
      </NewModal>
      <NewModal
        title="Configurar Tipos de Grupos por Tabulador"
        open={createParamModals?.param62 || editeParamModals?.param62}
        handleClose={() => {
          setCreateParamModals((prev) => ({ ...prev, param62: false }));
          setEditeParamModals((prev) => ({ ...prev, param62: false }));
          setEscuelasSelectedOptions("");
          setTipoGrupoSelectedOptions("");
          setTabuladoresSelectedOptions("");
        }}
        height={200}
        maxWidth={700}
        loading={loadingMDis}
        overflowY={"auto"}
        handleSubmit={handleSubmitParametro62}
      >
        <div style={{ padding: "25px" }}>
          <Grid
            container
            spacing={1}
            style={{
              alignItems: "center",
              position: "absolute",
              zIndex: 998,
            }}
          >
            <Grid item xs={3}>
              <label className={styles.inputLabel}>Escuela:</label>
            </Grid>
            <Grid item xs={8} style={{ zIndex: 1000 }}>
              <Select
                id="escuela"
                className="select-modal-container"
                classNamePrefix="select-modal"
                style={{ width: "200px" }}
                options={[...escuelasCatalogo]}
                value={escuelasSelectedOptions}
                onChange={setEscuelasSelectedOptions}
                isClearable={true}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Tipo de Grupo:</label>
            </Grid>
            <Grid item xs={8}>
              <Select
                id="tipo-grupo"
                className="select-modal-container"
                classNamePrefix="select-modal"
                style={{ width: "200px" }}
                options={[...tipoGrupoCatalogo]}
                value={tipoGrupoSelectedOptions}
                onChange={setTipoGrupoSelectedOptions}
                isClearable={true}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Tabulador:</label>
            </Grid>
            <Grid item xs={8}>
              <Select
                id="tabulador"
                className="select-modal-container"
                classNamePrefix="select-modal"
                style={{ width: "200px" }}
                options={[...tabuladoresCatalogo]}
                value={tabuladoresSelectedOptions}
                onChange={setTabuladoresSelectedOptions}
                isClearable={true}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Estatus:</label>
            </Grid>
            <Grid item xs={8}>
              {createParamModals?.param62 ? (
                <input
                  className={styles.filterInput}
                  value={"Activo"}
                  disabled
                />
              ) : (
                <Select
                  id="estatus"
                  className="select-modal-container"
                  classNamePrefix="select-modal"
                  style={{ width: "200px" }}
                  options={[
                    { value: "Activo", label: "Activo" },
                    { value: "Inactivo", label: "Inactivo" },
                  ]}
                  value={estatusSelectedOptions}
                  onChange={setEstatusSelectedOptions}
                  isClearable={true}
                />
              )}
            </Grid>
          </Grid>
        </div>
      </NewModal>
      <NewModal
        title="Configuración Clases Especiales para Proyecciones"
        open={editeParamModals?.param64}
        handleClose={() => {
          setEditeParamModals((prev) => ({ ...prev, param64: false }));
        }}
        maxWidth={800}
        height={600}
        loading={loadingMDis}
        overflowY={"auto"}
        handleSubmit={handleSubmitParametro64}
      >
        <Grid
          item
          xs={12}
          className="consult-tab-option_center"
          style={{ margin: "2% 0" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "2%",
              marginRight: "5%",
              height: "30px",
            }}
          >
            <EditButton onClick={() => agregarNuevaFila(nroFilas)}>
              Agregar
            </EditButton>
          </div>
          <div>
            <table
              className="input-table"
              style={{ width: "78%", marginTop: "1%" }}
            >
              <tr>
                <th>Clase Especial</th>
              </tr>
              {nroFilas.map((_, i) => (
                <tr key={i}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Select
                        id="proyecciones"
                        className="select-modal-container"
                        classNamePrefix="select-modal"
                        styles={{ menuList: () => ({ overflowY: "visible" }) }}
                        options={[...tipoClaseCatalogo]}
                        value={valoresTipoClase?.[i]}
                        onChange={(e) => {
                          const nuevosValores = [...valoresTipoClase];
                          nuevosValores[i] = e;
                          setValoresTipoClase(nuevosValores);
                        }}
                        isClearable={true}
                      />
                    </div>
                  </td>

                  <td>
                    <div
                      className="table-delete"
                      style={{ marginInline: "auto", zIndex: 99 }}
                      onClick={() => deleteRow(i)}
                    >
                      <TrashIcon />
                    </div>
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </Grid>
      </NewModal>
      <NewModal
        title={`Configuración ${title.nombre} No Envia a Nómina`}
        open={editeParamModals?.param66}
        handleClose={() => {
          setEditeParamModals((prev) => ({ ...prev, param66: false }));
        }}
        maxWidth={800}
        height={600}
        loading={loadingMDis}
        overflowY={"auto"}
        handleSubmit={handleSubmitParametro66}
      >
        <Grid
          item
          xs={12}
          className="consult-tab-option_center"
          style={{ margin: "2% 0" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "2%",
              marginRight: "5%",
              height: "30px",
            }}
          >
            <EditButton onClick={() => agregarNuevaFila(nroFilas)}>
              Agregar
            </EditButton>
          </div>
          <div>
            <table
              className="input-table"
              style={{ width: "78%", marginTop: "1%" }}
            >
              <tr>
                <th>{title.nombre}</th>
              </tr>
              {nroFilas.map((_, i) => (
                <tr key={i}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Select
                        id="proyecciones"
                        className="select-modal-container"
                        classNamePrefix="select-modal"
                        styles={{
                          maxWidth: 604,
                          menu: (styles) => ({ ...styles, zIndex: 999 }),
                          indicatorsContainer: (styles) => ({ ...styles }),
                        }}
                        options={
                          title.nombre === "Tipo Grupo"
                            ? [
                                ...groupTypeList.filter(
                                  (group) =>
                                    !valoresTipoClase.some(
                                      (clase) => clase.value === group.value
                                    )
                                ),
                              ]
                            : [
                                ...personList.filter(
                                  (person) =>
                                    !valoresTipoClase.some(
                                      (clase) => clase.value === person.value
                                    )
                                ),
                              ]
                        }
                        value={valoresTipoClase?.[i]}
                        onChange={(e) => {
                          const nuevosValores = [...valoresTipoClase];
                          nuevosValores[i] = e;
                          setValoresTipoClase(nuevosValores);
                        }}
                      />
                    </div>
                  </td>

                  <td>
                    <div
                      className="table-delete"
                      style={{ marginInline: "auto", zIndex: 99 }}
                      onClick={() => deleteRow(i)}
                    >
                      <TrashIcon />
                    </div>
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </Grid>
      </NewModal>
      <NewModal
        title="Configurar Claves Campus Planes Competencia"
        open={createParamModals?.param50 || editeParamModals?.param50}
        handleClose={() => {
          setCreateParamModals((prev) => ({ ...prev, param50: false }));
          setEditeParamModals((prev) => ({ ...prev, param50: false }));
          setFormDataParam50({
            clve_camp_fnza: "",
            clve_crra: "",
            porcentaje: "",
            estatus: "Activo",
          });
        }}
        height={200}
        maxWidth={750}
        loading={loadingMDis}
        overflowY={"auto"}
        handleSubmit={handleSubmitParametro50}
      >
        <div style={{ padding: "25px" }}>
          <Grid
            container
            spacing={1}
            style={{
              alignItems: "center",
              position: "absolute",
              zIndex: 998,
            }}
          >
            <Grid item xs={3}>
              <label className={styles.inputLabel}>Clave Campo Finanza:</label>
            </Grid>
            <Grid item xs={8} style={{ zIndex: 1000 }}>
              <input
                className={styles.filterInput}
                name="clve_camp_fnza"
                value={formDataParam50.clve_camp_fnza}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Clave Carrera:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                name="clve_crra"
                value={formDataParam50.clve_crra}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Porcentaje:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                type="number"
                min={0}
                name="porcentaje"
                value={formDataParam50.porcentaje}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Estatus:</label>
            </Grid>
            <Grid item xs={8}>
              {createParamModals?.param50 ? (
                <input
                  className={styles.filterInput}
                  value={"Activo"}
                  disabled
                />
              ) : (
                <Select
                  id="estatus"
                  className="select-modal-container"
                  classNamePrefix="select-modal"
                  style={{ width: "200px" }}
                  options={[
                    { value: "Activo", label: "Activo" },
                    { value: "Inactivo", label: "Inactivo" },
                  ]}
                  value={estatusSelectedOptions}
                  onChange={setEstatusSelectedOptions}
                  isClearable={true}
                />
              )}
            </Grid>
          </Grid>
        </div>
      </NewModal>

      <NewModal
        title={procesoMap[valueProceso]?.title}
        open={Boolean(procesoMap[valueProceso]) && openModalSelectTable}
        handleClose={() => {
          setOpenModalSelectTable(false);
          setLoadingMDis(false);
          setNroFilas([]);
          setValoresSelectTable([]);
          setEscuelasCatalogo([]);
        }}
        height={600}
        maxWidth={procesoMap[valueProceso]?.maxWidth || 700}
        loading={loadingMDis}
        overflowY="auto"
        handleSubmit={handleSubmitParamSelectTable}
      >
        <DynamicSelectTable
          columnTitle="Escuela"
          rows={nroFilas}
          addRow={() => agregarNuevaFila(nroFilas)}
          removeRow={(i) => deleteRow(i)}
          options={[...escuelasCatalogo]}
          values={valoresSelectTable}
          setValues={setValoresSelectTable}
        />
      </NewModal>

      <NewModal
        title="Configuración Horas Semanales OnLine"
        open={createParamModals?.param52}
        handleClose={() => {
          setCreateClaveEscuela52("");
          setCreateSemanas52("");
          setCreateCarrera52("");
          setCreateModulo52("");
          setCreateParamModals((prev) => ({ ...prev, param52: false }));
          setLoadingMDis(false);
        }}
        height={250}
        maxWidth={700}
        overflowY={"auto"}
        loading={loadingMDis}
        handleSubmit={handleSubmit52Nuevo}
      >
        <div style={{ padding: "25px" }}>
          <Grid
            container
            spacing={1}
            style={{
              marginBottom: "30px",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Grid item xs={3}>
              <label className={styles.inputLabel}>Clave Escuela:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                onChange={(e) => {
                  handleChangeEscuela52(e);
                }}
                value={createClaveEscuela52}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Número Semanas:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                onChange={(e) => {
                  handleChangeSemanas52(e);
                }}
                value={createSemanas52}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Clave Carrera:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                onChange={(e) => {
                  handleChangeCarrera52(e);
                }}
                value={createCarrera52}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Horas Módulo:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                onChange={(e) => {
                  handleChangeModulo52(e);
                }}
                value={createModulo52}
              />
            </Grid>
          </Grid>
        </div>
      </NewModal>
      <NewModal
        title="Configuración Días Previos para Actualizar Salón"
        open={createParamModals?.param63}
        handleClose={() => {
          setCreateSchool63("");
          setCreateDays63("");
          setCreateParamModals((prev) => ({ ...prev, param63: false }));
        }}
        height={250}
        maxWidth={800}
        loading={loadingMDis}
        handleSubmit={handleSubmit63Nuevo}
        overflowY={"unset"}
      >
        <div style={{ padding: "25px" }}>
          <Grid
            container
            spacing={1}
            style={{
              marginBottom: "30px",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Grid item xs={3}>
              <label className={styles.inputLabel}>Clave Escuela:</label>
            </Grid>
            <Grid item xs={8}>
              <Select
                id="campus"
                className="select-modal-container"
                classNamePrefix="select-modal"
                style={{ width: "200px" }}
                options={[...escuelasCatalogo]}
                value={createSchool63}
                onChange={setCreateSchool63}
                isClearable={true}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Días Previos:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                onChange={(e) => {
                  handleChangeDays63(e);
                }}
                value={createDays63}
              />
            </Grid>
          </Grid>
        </div>
      </NewModal>
      <NewModal
        title="Configurar Distribución"
        open={editeParamModals?.param58}
        handleClose={() => {
          setEditeParamModals((prev) => ({ ...prev, param58: false }));
          setFilaEditar(null);
          setEstatus("");
          setLoadingMDis(false);
        }}
        height={600}
        maxWidth={700}
        loading={loadingMDis}
        overflowY={"auto"}
        handleSubmit={handleSubmitDis}
      >
        <div style={{ padding: "25px" }}>
          <Grid
            container
            spacing={1}
            style={{
              marginBottom: "30px",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Grid item xs={3}>
              <label className={styles.inputLabel}>Campus:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                value={valoresModalDis[filaEditar]?.Campus}
                disabled
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Escuela:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                value={valoresModalDis[filaEditar]?.Escuela}
                disabled
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Porcentaje:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                value={
                  sumaTotalPorcentaje || valoresModalDis[filaEditar]?.Porcentaje
                }
                disabled
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Estatus:</label>
            </Grid>
            <Grid item xs={8}>
              <Select
                classNamePrefix="select-modal"
                options={estatusOptions}
                styles={{
                  container: (styles) => ({ ...styles, zIndex: 19 }),
                  singleValue: (styles) => ({ ...styles, textAlign: "center" }),
                }}
                onChange={setEstatus}
                value={
                  estatus || {
                    label: valoresModalDis[filaEditar]?.Estatus,
                    value:
                      valoresModalDis[filaEditar]?.Estatus === "Vigente"
                        ? "vigente"
                        : "no vigente",
                  }
                }
              />
            </Grid>
          </Grid>
        </div>
        <Grid
          item
          xs={12}
          className="consult-tab-option_center"
          style={{ marginTop: "-4%" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "2%",
              marginRight: "5%",
              height: "30px",
            }}
          >
            <EditButton onClick={() => agregarNuevaFila(nroFilas)}>
              Agregar
            </EditButton>
          </div>
          <div>
            <table
              className="input-table"
              style={{ width: "78%", marginTop: "1%" }}
            >
              <tr>
                <th>Porcentaje Parcial</th>
                <th>Porcentaje a Otorgar</th>
              </tr>
              {nroFilas.map((_, i) => (
                <tr key={i}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <input
                        className="filter-input"
                        style={{ width: "35%" }}
                        type="number"
                        min={0}
                        max={100}
                        value={valoresPorcentaje?.[i]?.[0]}
                        onChange={(e) => {
                          const nuevosValores = [...valoresPorcentaje];
                          nuevosValores[i][0] = e.target.value;

                          setValoresPorcentaje(nuevosValores);
                        }}
                      />
                      <span>%</span>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <input
                        className="filter-input"
                        type="number"
                        style={{ width: "35%" }}
                        min={0}
                        max={100}
                        value={valoresPorcentaje?.[i]?.[1]}
                        onChange={(e) => {
                          const nuevosValores = [...valoresPorcentaje];
                          nuevosValores[i][1] = e.target.value;
                          setValoresPorcentaje(nuevosValores);
                        }}
                      />
                      <span>%</span>
                    </div>
                  </td>
                  <td>
                    <div
                      className="table-delete"
                      style={{ marginLeft: "38.5%", zIndex: 99 }}
                      onClick={() => deleteRow(i)}
                    >
                      <TrashIcon />
                    </div>
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </Grid>
      </NewModal>

      <NewModal
        title="Configurar Excepción Día Última Fecha Clase"
        open={createParamModals?.param60}
        handleClose={() => {
          setCreateParamModals((prev) => ({ ...prev, param60: false }));
          setLoadingMDis(false);
          setDataModalParam60([]);
        }}
        height={200}
        maxWidth={800}
        loading={loadingMDis}
        overflowY={"auto"}
        handleSubmit={handleSubmitParam60Nuevo}
      >
        <div style={{ padding: "25px" }}>
          <Grid
            container
            spacing={1}
            style={{
              marginBottom: "30px",
              alignItems: "center",
              justifyContent: "space-evenly",
            }}
          >
            <Grid item xs={3}>
              <label className={styles.inputLabel}>Clave Escuela:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                value={dataModalParam60[0] || ""}
                onChange={(e) => handleInputChange(0, e)}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Clave Grupo:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                value={dataModalParam60[1] || ""}
                onChange={(e) => handleInputChange(1, e)}
              />
            </Grid>

            <Grid item xs={3}>
              <label className={styles.inputLabel}>Días:</label>
            </Grid>
            <Grid item xs={8}>
              <input
                className={styles.filterInput}
                value={dataModalParam60[2] || ""}
                onChange={(e) => handleInputChange(2, e)}
              />
            </Grid>
          </Grid>
        </div>
      </NewModal>
      <NewModal
        title={`Configuración Tipo Grupo No Contabilizan Horas`}
        open={editeParamModals?.param67}
        handleClose={() => {
          setEditeParamModals((prev) => ({ ...prev, param67: false }));
        }}
        maxWidth={800}
        height={600}
        loading={loadingMDis}
        overflowY={"auto"}
        handleSubmit={handleSubmitParametro67}
      >
        <Grid
          item
          xs={12}
          className="consult-tab-option_center"
          style={{ margin: "2% 0" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "2%",
              marginRight: "5%",
              height: "30px",
            }}
          >
            <EditButton onClick={() => agregarNuevaFila(nroFilas)}>
              Agregar
            </EditButton>
          </div>
          <div>
            <table
              className="input-table"
              style={{ width: "78%", marginTop: "1%" }}
            >
              <tr>
                <th>Tipo de Grupo</th>
              </tr>
              {nroFilas.map((_, i) => (
                <tr key={i}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Select
                        id="proyecciones"
                        className="select-modal-container"
                        classNamePrefix="select-modal"
                        styles={{
                          maxWidth: 604,
                          menu: (styles) => ({ ...styles, zIndex: 999 }),
                          indicatorsContainer: (styles) => ({ ...styles }),
                        }}
                        options={groupTypeList.filter(
                          (group) =>
                            !valoresTipoClase.some(
                              (clase) => clase.value === group.value
                            )
                        )}
                        value={valoresTipoClase?.[i]}
                        onChange={(e) => {
                          const nuevosValores = [...valoresTipoClase];
                          nuevosValores[i] = e;
                          setValoresTipoClase(nuevosValores);
                        }}
                      />
                    </div>
                  </td>

                  <td>
                    <div
                      className="table-delete"
                      style={{ marginInline: "auto", zIndex: 99 }}
                      onClick={() => deleteRow(i)}
                    >
                      <TrashIcon />
                    </div>
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </Grid>
      </NewModal>
      <NewTraduccionInterfaceNominaAgrupadorHorasOnlineModal
        open={createParamModals?.param68}
        close={setCreateParamModals}
        userName={userName}
        info={dataFinal}
        id={valueProceso}
        getDataTable={getDataTable}
      />
      <EditTraduccionInterfaceNominaAgrupadorHorasOnlineModal
        open={editeParamModals?.param68}
        close={setEditeParamModals}
        userName={userName}
        info={valoresTipoClase}
        allInfo={dataFinal}
        id={valueProceso}
        getDataTable={getDataTable}
      />
      <EditConfiguracionMostrarTiposDeGruposOnline
        open={editeParamModals?.param69}
        close={setEditeParamModals}
        id={valueProceso}
        groupTypeList={groupTypeList}
        nroFilas={nroFilas}
        valoresTipoClase={valoresTipoClase}
        loadingMDis={loadingMDis}
        setTableEdit={setTableEdit}
        setLoadingMDis={setLoadingMDis}
        setValoresTipoClase={setValoresTipoClase}
        setNroFilas={setNroFilas}
        agregarNuevaFila={agregarNuevaFila}
        getDataTable={getDataTable}
        deleteRow={deleteRow}
      />
      <EditAsignacionDocenteAlumnosInscritos
        open={editeParamModals?.param04}
        close={setEditeParamModals}
        id={valueProceso}
        options={modalOptions}
        nroFilas={nroFilas}
        valoresTipoClase={valoresTipoClase}
        dataFinal={dataFinal}
        filaEditar={filaEditar}
        loadingMDis={loadingMDis}
        setTableEdit={setTableEdit}
        setLoadingMDis={setLoadingMDis}
        setValoresTipoClase={setValoresTipoClase}
        setNroFilas={setNroFilas}
        agregarNuevaFila={agregarNuevaFila}
        getDataTable={getDataTable}
        deleteRow={deleteRow}
      />
      <AsignacionDocenteOnlineOnlineAlumnosInscritos
        open={editeParamModals?.param35}
        close={setEditeParamModals}
        id={valueProceso}
        options={modalOptions}
        nroFilas={nroFilas}
        valoresTipoClase={valoresTipoClase}
        dataFinal={dataFinal}
        filaEditar={filaEditar}
        loadingMDis={loadingMDis}
        setTableEdit={setTableEdit}
        setLoadingMDis={setLoadingMDis}
        setValoresTipoClase={setValoresTipoClase}
        setNroFilas={setNroFilas}
        agregarNuevaFila={agregarNuevaFila}
        getDataTable={getDataTable}
        deleteRow={deleteRow}
      />
      <EditarConceptosDePagoParaGruposCerrados
        open={editeParamModals?.param70}
        close={setEditeParamModals}
        userName={userName}
        info={valoresTipoClase}
        allInfo={dataFinal}
        id={valueProceso}
        options={options}
        getDataTable={getDataTable}
        campusUser2={campusUser2}
      />
      <CreateConceptosDePagoParaGruposCerrados
        open={createParamModals?.param70}
        close={setCreateParamModals}
        userName={userName}
        id={valueProceso}
        allInfo={dataFinal}
        options={options}
        getDataTable={getDataTable}
        campusId={campusId}
        campusUser2={campusUser2}
      />
      <EditConfiguracionAsignacionDocenteEscuelasProfesor
        open={editeParamModals?.param32}
        close={setCreateParamModals}
        id={valueProceso}
        escuelasCatalogo={escuelasCatalogo}
        nroFilas={nroFilas}
        valoresTipoClase={valoresTipoClase}
        dataFinal={dataFinal}
        filaEditar={filaEditar}
        loadingMDis={loadingMDis}
        setTableEdit={setTableEdit}
        setLoadingMDis={setLoadingMDis}
        setValoresTipoClase={setValoresTipoClase}
        setNroFilas={setNroFilas}
        agregarNuevaFila={agregarNuevaFila}
        getDataTable={getDataTable}
        deleteRow={deleteRow}
      />
    </Contenedor>
  );
};

export default ParametrosInternos;
